module.exports = " <div class=binary-choice> <button id=binary-no class=\"binary-choice__item button\" v-on:click=choose(false)> {{noMessage}} </button> <button id=binary-yes class=\"binary-choice__item button button--encourage\" v-on:click=choose(true)> {{yesMessage}} </button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BinaryChoice.vue
 ** module id = 12
 ** module chunks = 1
 **/